module.exports = __webpack_public_path__ + "static/img/nyfb.fabcc06.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/images/nyfb.png
// module id = 7mYO
// module chunks = 1